import AvatarMenuNavItem from './AvatarMenuNavItem';

export default AvatarMenuNavItem;
